import { render } from "./freelancer-sidebar.vue?vue&type=template&id=1a830c9e"
import script from "./freelancer-sidebar.vue?vue&type=script&lang=js"
export * from "./freelancer-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__